import { AlertColor } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import strings from '../../../../../common/Translation/Translate';
import Notification from '../../../../../components/Notification';
import { routes } from '../../../../../utils/constants/routes';
import { URLS } from '../../../../../utils/constants/urls';
import { languages, selectIntegration } from '../../../../../utils/redux/reducer/authentication-slice';
import AddEdit from '../../../CommonPage/AddEdit';
import { AddEditVenueForm } from './AddEditVenueForm';

interface AddEditVenueFormProps {
  pageResponseData?: any;
  dropdownData?: any;
  getPageData: (id: number) => void;
}

const VenueInfoTab: FC<AddEditVenueFormProps> = ({ pageResponseData, dropdownData, getPageData }) => {
  const { id } = useParams() as any;
  const queryStings = useLocation().search as any;
  const queryStingId = new URLSearchParams(queryStings).get('id') as string;
  const Navigate = useNavigate();
  const languageList = useSelector(languages) as any;
  const integration = useSelector(selectIntegration);
  const isOperaIntegration = Boolean(integration && integration.includes('OPERA'));
  const [pageResponse, setPageResponse] = useState<any>(pageResponseData || []);
  const [message, setMessage] = useState<{
    display: boolean;
    severity: AlertColor | null;
    message: string;
  }>({
    display: false,
    severity: null,
    message: '',
  });

  useEffect(() => {
    if (id || queryStingId) {
      setPageResponse(pageResponseData);
    }
  }, [id, queryStingId, pageResponseData]);

  useEffect(() => {
    handleSetModel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSetModel = () => {
    const baseForm = AddEditVenueForm(strings, isOperaIntegration);
    const newArray = [...baseForm] as any;
    languageList !== undefined &&
      languageList?.forEach((languae: any) => {
        const newObject = { ...baseForm[0] };
        const newObject1 = { ...baseForm[1] };
        newObject1.field = 'name_' + languae.value;
        newObject1.label = newObject1.label + ' (' + languae.text + ')';
        newObject.field = 'description_' + languae.value;
        newObject.label = newObject.label + ' (' + languae.text + ')';
        newArray.unshift(newObject, newObject1);
      });
    return newArray.filter((item: any) => item.field !== 'name' && item.field !== 'description');
  };

  const pageConfig = {
    title: id ? strings.venue_title_edit : strings.venue_title_create,
    successMessage: id ? strings.common_update_message : strings.common_save_message,
    addEditApiUrl: id || queryStingId ? URLS.get_edit_delete_VenueById(id || queryStingId) : URLS.addVenue,
    initialApi: URLS.get_edit_delete_VenueById(id),
    formModel: handleSetModel(),
    navigateToPage: ``,
    isCustomResponse: true,
    queryStingId: queryStingId,
    hideClose: true,
  };

  const closeNotification = (value: boolean) => {
    setMessage({ ...message, display: value });
  };

  const handleCustomResponse = (custom: any) => {
    const localizedAttributes = [] as any;
    languageList !== undefined &&
      languageList?.map((item: { text: string; value: string }) =>
        localizedAttributes.push({
          language: item.value,
          description: custom['name_' + item.value],
          name: custom['description_' + item.value],
        }),
      );

    const request = {
      parentVenueId: custom.parentVenueId ? custom.parentVenueId?.value : '',
      venueTypeId: custom.venueTypeId ? custom.venueTypeId?.value : '',
      taxGroupOnGuestChargeId: custom.taxGroupOnGuestCharge?.value ?? null,
      taxGroupOnHallRentalId: custom.taxGroupOnHallRental?.value ?? null,
      taxGroupOnServiceChargeId: custom.taxGroupOnServiceCharge?.value ?? null,
      available: custom.available?.value || false,
    };

    return { ...custom, localizedAttributes: localizedAttributes, ...request };
  };

  const customCallbackResponse = (callbackValue: any) => {
    if (!id) {
      Navigate(`${routes.addVenue}?id=${callbackValue.id}`);
    }
    getPageData(callbackValue.id);
  };

  return (
    <>
      {message.display && (
        <Notification
          isOpen={message.display}
          message={message.message}
          severity={message.severity as AlertColor}
          closeNotification={closeNotification}
        />
      )}
      <AddEdit
        dropdownValue={dropdownData}
        customCallbackResponse={customCallbackResponse}
        pageConfig={pageConfig}
        pageResponse={pageResponse}
        handleCustomResponse={handleCustomResponse}></AddEdit>
    </>
  );
};
export default VenueInfoTab;
